import { texts as pt_BR } from "./pt_BR";

const texts_import = pt_BR;

export const translate = function (fieldOrText = "", defaultText = "") {
    if(!!!fieldOrText) return fieldOrText;
    let searchField = texts_import;
    
    if (fieldOrText && typeof fieldOrText === "string") {

        if(searchField.hasOwnProperty(fieldOrText.toString())) return searchField[fieldOrText.toString()];
        //eslint-disable-next-line
        fieldOrText.split(".").map(field => {
            if(searchField.hasOwnProperty(field)) {
                searchField = searchField[field]
                return searchField;
            };

            searchField =  fieldOrText;
        });
    }

    if(defaultText !== "" && searchField ===fieldOrText) return defaultText;
    searchField = searchField ? searchField : fieldOrText;
    
    return searchField
}